<template>
  <div>
    <v-checkbox :input-value="data.header.type.getValue(data.item, data.header.type)" :readonly="true"></v-checkbox>
  </div>
</template>

<script>

export default {
  name: "BooleanInjectableComponent",
  components: {
  },
  props: ["data"],
};
</script>


